import { Component, Input } from "@angular/core";

import { EventsHubService, ExamMessage, EXAMMESSAGETYPE } from "src/app/services/eventshub.service";
import { PageObjectButton } from "src/app/models/pageobjectbutton";

@Component({
  selector: "hkt-pageobjectbutton",
  templateUrl: "./pageobjectbutton.component.html",
  styleUrls: ["./pageobjectbutton.component.scss"],
})
export class PageObjectButtonComponent {
  @Input("obj") obj: PageObjectButton;
  @Input("mode") mode: string;

  constructor(private eventsHubService: EventsHubService) {}

  onClick(): void {
    if (!this.obj.visible) {
      return;
    }
    if (this.mode == "edit") {
      return;
    }
    if (this.mode != "exam") {
      return;
    }
    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = this.obj.action;
    this.eventsHubService.setExamMessage(msg);
  }
}
